export const INITIAL = '_initial_';
export const PENDING = '_pending_';
export const SUCCESS = '_success_';
export const WARNING = '_warning_';
export const ERROR = '_error_';
export const WAITING_FOR_HOST = '_waiting_for_host_';
export const MEETING_PREP = '_meeting_prep_';
export const MEETING_INVALIDATED = '_meeting_invalidated_';
